import { AssetReference } from '@opallabs/cassini'
import { renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../AccountName'
import { ContentAvatar } from '../../../../ContentAvatar'
import { Module } from '../../../helpers/types'
import { styles } from './styles'

type Props = {
  accountImage: AssetReference
  accountName: string
  collabEnabled?: boolean
  collabAccount?: string
  index: number
  sections: Module[]
}

export const FacebookStoryHeader: React.FC<Props> = ({
  accountImage,
  accountName,
  collabEnabled,
  collabAccount,
  index,
  sections,
}) => (
  <div css={styles.headerWrapper}>
    <div
      css={styles.loaderWrapper}
      className={kuiperClassNames('carousal-loader-wrapper')}
    >
      {sections.map((section, i) => (
        <div
          className={kuiperClassNames(
            `carousal-loader-bar${i <= index ? '-active' : ''}`
          )}
          css={styles.getLoaderStyle(i <= index)}
          key={`carousal-loader-bar-${i}`}
        />
      ))}
    </div>
    <div css={styles.accountHeaderWrapper}>
      <div
        css={styles.flexCenterRow}
        className={kuiperClassNames({ [styles.withCollab]: collabEnabled })}
      >
        <div css={styles.collabAvatarContainer}>
          <ContentAvatar
            assetReference={accountImage}
            size={36}
            style={styles.accountImage}
          />
          {collabEnabled && (
            <ContentAvatar
              assetReference={null}
              size={36}
              style={styles.collabAvatarSecondary}
            />
          )}
        </div>
        <AccountName
          color="white"
          name={accountName}
          style={styles.accountName}
          size={14}
        />
        {collabEnabled && (
          <>
            <span css={styles.collabSeparator}> and </span>
            <AccountName
              color={collabAccount ? 'white' : 'orange'}
              name={collabAccount || 'No collab account'}
              style={styles.accountName}
              size={14}
            />
          </>
        )}
        <span>1m</span>
      </div>
      <ul css={styles.headerIcons}>
        <li css={styles.headerIconMore}>
          {renderIcon('facebook-mobile-story-more', {
            height: 6,
            width: 22,
            ariaMode: 'hidden',
          })}
        </li>
        <li css={styles.headerIconClose}>
          {renderIcon('facebook-mobile-close', {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>
  </div>
)
